import { render, staticRenderFns } from "./Orderitems.vue?vue&type=template&id=7b5f13d8&scoped=true&"
import script from "./Orderitems.vue?vue&type=script&lang=js&"
export * from "./Orderitems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5f13d8",
  null
  
)

export default component.exports